import React from 'react';
import { isEmpty } from 'lodash';
import { COLORS } from 'Components/utils/color/colors';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { ProductStrengths } from 'Components/widgets/product-strengths/ProductStrengths';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
type Props = {
  displayLoadMore: boolean;
  id: string;
  isExclusiveCollection: boolean;
  items: Array<{
    iconName: IconName;
    label: string;
    url?: string;
  }>;
  resort: Product;
  title: string;
};
export const ProductStrengthsLine = ({
  displayLoadMore,
  id,
  items,
  isExclusiveCollection,
  resort,
  title,
}: Props) => {
  if (isEmpty(items) || !resort) {
    return null;
  }

  const { isExclusiveCollection: isProductExclusiveCollection, isJoyview } = resort;
  const isEC = isProductExclusiveCollection || isExclusiveCollection;
  const colorDef = isEC ? COLORS.ULTRAMARINE : COLORS.BLACK;
  const color = isJoyview ? COLORS.BLUE_WAVE : colorDef;
  const filledItems = items.map((item) => ({
    ...item,
    color,
    trackingData: {
      actionGA: 'productStrenghtsBanner',
      labelGA: item.label,
    },
  }));
  return (
    <SiteContainer className="Line" data-testid="productStrenghts" id={id}>
      <LineTitle>{title}</LineTitle>
      <ProductStrengths
        displayLoadMore={displayLoadMore}
        isExclusiveCollection={isEC}
        items={filledItems}
      />
    </SiteContainer>
  );
};
